import { render, staticRenderFns } from "./Examples.vue?vue&type=template&id=7fab3c4e&lang=pug&"
import script from "./Examples.vue?vue&type=script&lang=js&"
export * from "./Examples.vue?vue&type=script&lang=js&"
import style0 from "./Examples.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports